import { useState, useCallback } from 'react';

import Toast from 'common/types/IToast';
import IToastType from 'common/types/IToastType';
import IUseToast from 'common/types/IUseToast';

const useToast = ():IUseToast => {
  const [toasts, setToasts] = useState<Array<Toast>>([]);

  const addToast = useCallback((message: string, type?: IToastType) => {
    setToasts((perviousToasts) => [
      ...perviousToasts,
      {
        id: Date.now().toString(),
        message,
        type,
      },
    ]);
  }, []);

  const removeToast = useCallback((toastId: string) => {
    setToasts((perviousToasts) => {
      if(!perviousToasts) {
        // plays nice with react transition group
        return [];
      }
      return perviousToasts.filter((({ id }) => id !== toastId));
    });
  }, []);

  return {
    addToast,
    removeToast,
    toasts,
  };
};

export default useToast;